import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TokensDto } from '../../core/models/api.models';
import { PlaylistsService } from '../../core/services/playlists.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tokens-info',
  templateUrl: './tokens-info.page.html',
  styleUrls: ['./tokens-info.page.scss']
})
export class TokensInfoPage implements OnInit, OnDestroy {
  tokens?: TokensDto | null;
  loading = false;
  private subs: Subscription[] = [];

  constructor(private playlistsService: PlaylistsService, private router: Router) {}

  ngOnInit(): void {
    this.loadTokens();
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  goConvert(): void {
    this.router.navigateByUrl('/app/convert');
  }

  goAccount(): void {
    this.router.navigateByUrl('/app/account');
  }

  private loadTokens(): void {
    this.loading = true;
    const sub = this.playlistsService.getMyTokens().subscribe({
      next: res => {
        this.tokens = res;
        this.loading = false;
      },
      error: () => {
        this.tokens = null;
        this.loading = false;
      }
    });
    this.subs.push(sub);
  }
}
